module.exports = __webpack_public_path__ + "static-v-shop/1792141392954/img/logo_amex.2dc1fd72.svg";